import { ReactComponent as SimeraBlackLogo } from '$icons/simera-dark logo.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import CurrencySelector from '$components/EmployerDashboard/CurrencySelector/CurrencySelector';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { logoutAuthAction } from '../../store/legacy/auth';

const SPKShareHeader = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [t, i18next] = useTranslation('global');
  const { shareReferenceId } = useParams();
  const { shareCandidatesIds } = useParams();
  const { isLoggedIn, serverEmployer } = useAppSelector((state) => state.auth);
  const isAuthenticatedEmployer = isLoggedIn && !!serverEmployer;

  const handleCreateAccount = () => {
    navigate('/client_register', {
      state: { shareCandidatesIds, shareReferenceId },
    });
  };
  const handleLogin = () => {
    navigate('/client_login', {
      state: { shareCandidatesIds, shareReferenceId },
    });
  };
  const handleGoToDashboard = () => {
    navigate('/employer-dashboard/positions');
  };
  const handleLogout = () => {
    dispatch(logoutAuthAction(i18next.language));
  };

  return (
    <nav className="flex justify-between py-4 bg-white mb-4">
      <div className="container flex max-[360px]:flex-col px-2 lg:px-0 m-auto">
        <div className="w-full flex items-center gap-4">
          <SimeraBlackLogo className="w-24" />
          <div className="bg-[#BFEFEC] font-semibold px-2 text-sm rounded text-[#016F68]">
            Shortlist
          </div>
        </div>
        <div className="flex flex-row items-center gap-4">
          <CurrencySelector />
          {isAuthenticatedEmployer ? (
            <>
              <button
                type="button"
                className="text-employer-primary bg-employer-primary/10 text-nowrap px-6 py-2 rounded-full text-sm font-semibold  max-[360px]:mt-4"
                onClick={handleGoToDashboard}
              >
                {t('sharedPosition.goToDashboard')}
              </button>
              <button
                type="button"
                className="text-white bg-employer-primary text-nowrap px-6 py-2 rounded-full text-sm font-semibold  max-[360px]:mt-4"
                onClick={handleLogout}
              >
                {t('authButton.logout')}
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="text-employer-primary bg-employer-primary/10 text-nowrap px-6 py-2 rounded-full text-sm font-semibold  max-[360px]:mt-4"
                onClick={handleCreateAccount}
              >
                {t('sharedPosition.createAccount')}
              </button>
              <button
                type="button"
                className="text-white bg-employer-primary text-nowrap px-6 py-2 rounded-full text-sm font-semibold  max-[360px]:mt-4"
                onClick={handleLogin}
              >
                {t('sharedPosition.login')}
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default SPKShareHeader;
